module.exports = __webpack_public_path__ + "71f665108ad7d48cf1d058e814a86c85.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/open-graph.png
// module id = 477
// module chunks = 0